import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Church, ArrowLeft } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { APP_NAME } from "@/lib/constants";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyMember() {
  const { number } = useParams();
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/public/anggota/verify/${encodeURIComponent(number)}`)
      .then((r) => setResult(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Terjadi kesalahan"))
      .finally(() => setLoading(false));
  }, [number]);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <div className="max-w-md w-full">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-10 w-10 rounded-lg bg-primary text-primary-foreground flex items-center justify-center font-heading text-lg font-bold">S</div>
          <div>
            <div className="font-heading font-bold text-primary">{APP_NAME}</div>
            <div className="text-xs text-muted-foreground">Verifikasi Kartu Anggota</div>
          </div>
        </div>

        <Card className="overflow-hidden">
          {loading && (
            <CardContent className="p-8 text-center text-sm text-muted-foreground">Memverifikasi kartu…</CardContent>
          )}
          {!loading && error && (
            <div>
              <div className="bg-rose-500 text-white p-6 flex items-center gap-3">
                <XCircle className="h-8 w-8" />
                <div>
                  <div className="font-heading font-bold text-lg">Kartu Tidak Valid</div>
                  <div className="text-sm opacity-90">Data kartu tidak dikenali dalam sistem.</div>
                </div>
              </div>
              <CardContent className="p-6 text-sm text-muted-foreground">
                <div>Nomor kartu <span className="font-mono">{number}</span> tidak ditemukan.</div>
                <div className="mt-2 text-xs">Jika kartu ini seharusnya valid, hubungi Sekretariat Klasis.</div>
              </CardContent>
            </div>
          )}
          {!loading && result && (
            <div data-testid="verify-success">
              <div className="bg-gradient-to-br from-emerald-600 to-emerald-700 text-white p-6 flex items-center gap-3">
                <CheckCircle2 className="h-8 w-8" />
                <div>
                  <div className="font-heading font-bold text-lg">Kartu Terverifikasi</div>
                  <div className="text-sm opacity-90">Anggota terdaftar resmi di GPDP Klasis Mimika.</div>
                </div>
              </div>
              <CardContent className="p-6 space-y-3">
                <div>
                  <div className="text-[0.65rem] uppercase tracking-widest text-muted-foreground">Nama Anggota</div>
                  <div className="font-heading font-bold text-xl mt-1">{result.name}</div>
                </div>
                <div>
                  <div className="text-[0.65rem] uppercase tracking-widest text-muted-foreground">No Anggota</div>
                  <div className="font-mono text-sm mt-1">{result.member_number}</div>
                </div>
                <div>
                  <div className="text-[0.65rem] uppercase tracking-widest text-muted-foreground flex items-center gap-1"><Church className="h-3 w-3" /> Jemaat</div>
                  <div className="text-sm mt-1">{result.church?.name || "—"}</div>
                </div>
                {result.wadah && (
                  <div>
                    <div className="text-[0.65rem] uppercase tracking-widest text-muted-foreground">Wadah Pelayanan</div>
                    <div className="text-sm mt-1">{result.wadah}</div>
                  </div>
                )}
                <div>
                  <div className="text-[0.65rem] uppercase tracking-widest text-muted-foreground">Terdaftar Sejak</div>
                  <div className="text-sm mt-1">{result.since}</div>
                </div>
              </CardContent>
            </div>
          )}
        </Card>

        <Link to="/public" className="text-xs text-muted-foreground hover:text-primary flex items-center gap-1 mt-4 justify-center">
          <ArrowLeft className="h-3 w-3" /> Kembali ke Portal Publik
        </Link>
      </div>
    </div>
  );
}
